import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { SectionWrapper } from 'Components/Section/SectionWrapper'
import { SectionTitle } from 'Components/Section/SectionTitle'
import SubmitButton from 'Components/Form/SubmitButton'
import { SubmitButtonBlock } from 'Components/Form/SubmitButton/SubmitButtonBlock'
import Form from 'Components/Form'
import UIBlocker from '../UIBlocker'
import { SelectDashboard } from '../../../../../../Components/Form'
import { missionsLimits } from '../options'
import InputLabelWithHint from '../../../../../../Components/InputLabelWithHint'

const BaDetails = ({
  isSaving,
  isEdit,
  defaultValues,
  updateBaCitySettings,
  cityData,
}) => {
  const [values, setValues] = useState(defaultValues)

  const { baWeeklyMissionsLimit, tlaWeeklyMissionsLimit } = values

  const editBaSettingsProp = (prop, value) => {
    setValues(prev => ({
      ...prev,
      [prop]: value ? Number(value) : null,
    }))
  }

  const onSubmitBaSettings = async (form, isValid) => {
    if (isValid) {
      for (const key in values) {
        values[key] = values[key] === null ? null : +values[key]
      }
      await updateBaCitySettings(values)
    }
  }
  return (
    <SectionWrapper className="section-wrapper">
      <Form onSubmit={onSubmitBaSettings}>
        <SectionTitle>BA settings</SectionTitle>
        <Row>
          <Col xs={3}>
            <InputLabelWithHint
              label="Max Missions per BA per Week"
              hint="Select the maximum number of missions a regular Brand Ambassador can book in this city per week. Select 'No Limit' for unrestricted booking."
            />
            <SelectDashboard
              options={missionsLimits}
              onChange={(e, k, v) =>
                editBaSettingsProp('baWeeklyMissionsLimit', v)
              }
              input={{
                value: baWeeklyMissionsLimit || null,
              }}
            />
          </Col>
          <Col xs={3}>
            <InputLabelWithHint
              label="Max Missions per TLA per Week"
              hint="Select the maximum number of missions a Team Leader can book in this city per week. Select 'No Limit' for unrestricted booking. Only applicable if Team Leader mode is enabled."
            />
            {cityData.teamLeaderEnabled ? (
              <SelectDashboard
                options={missionsLimits}
                onChange={(e, k, v) =>
                  editBaSettingsProp('tlaWeeklyMissionsLimit', v)
                }
                input={{
                  value: tlaWeeklyMissionsLimit || null,
                }}
              />
            ) : (
              <div
                style={{ display: 'flex', height: 50, alignItems: 'center' }}
              >
                {tlaWeeklyMissionsLimit || 'No limit'}
              </div>
            )}
          </Col>
        </Row>

        {isEdit && (
          <SubmitButtonBlock float="left" marginTop={10}>
            <SubmitButton
              value="Save"
              onClick={function(e) {
                e.preventDefault()
              }}
            />
          </SubmitButtonBlock>
        )}
        {isSaving ? <UIBlocker>Loading...</UIBlocker> : null}
      </Form>
    </SectionWrapper>
  )
}

export default BaDetails
